import { z } from "zod"

import openDialog from "./office-dialog"
import { PAGES } from "../context/PageContext"

const DEFAULT_TOKEN_LIFETIME_SECONDS = 900

const IcertisAuthFailureSchema = z.object({
  error: z.string().min(1),
  details: z.string().optional(),
})

const IcertisTokensSchema = z.object({
  authToken: z.string().min(1),
  refreshToken: z.string().min(1),
  expiresIn: z.number().int().positive().default(DEFAULT_TOKEN_LIFETIME_SECONDS),
})

export type IcertisTokens = z.infer<typeof IcertisTokensSchema>

export const authenticateIcertis = async (icmBaseUrl: string): Promise<IcertisTokens> => {
  const payload = await openDialog({
    page: PAGES.icertisAuthPage,
    dialogOptions: { height: 60, width: 40 },
    additionalParams: { icmBaseUrl },
  })

  const failure = IcertisAuthFailureSchema.safeParse(payload)
  if (failure.success) {
    throw new Error(failure.data.details ? `${failure.data.error}: ${failure.data.details}` : failure.data.error)
  }

  const tokens = IcertisTokensSchema.safeParse(payload)
  if (!tokens.success) {
    throw new Error("Icertis sign-in finished without returning usable tokens.")
  }

  return tokens.data
}
